import type { ReactNode } from 'react'
import { InfoCircleIcon } from '@/components/ui/icons'

/**
 * The shared page banner at dialog scale, as an information point: the grey
 * block the attendee detail draws when CTA capture is blocked, here for a
 * caveat stated before a write. Tighter padding for the dialog, and the icon
 * on the title line rather than centred against the block, since the title is
 * what the icon qualifies (a refresh, a lock) and the description may run on.
 *
 * `icon` defaults to the info circle; a caller passes its own when the hint
 * is one of a pair that an icon tells apart at a glance.
 */
export function DialogHint({
	title,
	description,
	icon = <InfoCircleIcon />
}: {
	title: string
	description: ReactNode
	icon?: ReactNode
}) {
	return (
		<div className='flex items-start gap-3 rounded-2xl bg-grey-100 p-4'>
			<span className='mt-0.5 flex size-5 shrink-0 text-neutral-500 [&>svg]:size-5'>
				{icon}
			</span>
			<div className='flex flex-col gap-1'>
				<p className='font-medium text-base text-grey-1000'>{title}</p>
				<p className='text-grey-700 text-sm'>{description}</p>
			</div>
		</div>
	)
}
